import { Directive, EventEmitter, HostListener, Input, Output, Renderer2 } from '@angular/core';
import { IProduct } from '../../../../shared/models/product.model';

@Directive({
    selector: '[appWidgetDeviceResizer]',
    standalone: false
})
export class WidgetDeviceResizerDirective {
  startRender: { width: number; left: number };
  widthOfOneRail: number;
  minSize: number;
  maxSize: number;
  public deltaRight;

  private onMoveListener = this.onMove.bind(this);
  private onUpListener = this.onUp.bind(this);

  @Input() widgetCmp: HTMLElement;
  @Input() widgetRect: HTMLElement;
  @Input() device: IProduct;
  @Input() widthInSlots: number;
  @Input() minSizeInSlots: number;
  @Input() maxSizeInSlots: number;

  @Output() newSize = new EventEmitter<number>();
  @Output() resizing = new EventEmitter<boolean>();
  @Output() movingResizedInProcess = new EventEmitter<number>();

  constructor(private renderer: Renderer2) { }

  @HostListener('pointerdown', ['$event'])
  @HostListener('mousedown', ['$event'])
  onDown(event) {
    event.preventDefault();
    this.resizing.emit(true);
    this.startRender = {
      left: this.widgetCmp.getBoundingClientRect().left,
      width: this.widgetCmp.getBoundingClientRect().width,
    };
    this.widthOfOneRail = this.startRender.width / this.widthInSlots;
    this.minSize = this.minSizeInSlots * this.widthOfOneRail;
    this.maxSize = this.maxSizeInSlots * this.widthOfOneRail;

    this.deltaRight = 0;

    if (typeof PointerEvent !== 'undefined') {
      window.addEventListener('pointermove', this.onMoveListener);
      window.addEventListener('pointerup', this.onUpListener);
    } else {
      window.addEventListener('mousemove', this.onMoveListener);
      window.addEventListener('mouseup', this.onUpListener);
    }
  }

  @HostListener('touchstart', ['$event'])
  touchStart(event) {
    event.preventDefault();
    event.stopPropagation();
  }

  @HostListener('touchmove', ['$event'])
  touchMove(event) {
    event.preventDefault();
  }

  onMove(event: MouseEvent) {
    event.preventDefault();
    const dragPositionX = Math.round(event.pageX) - this.startRender.left;

    this.deltaRight = Math.min(Math.max(dragPositionX, this.minSize), this.maxSize);
    this.renderer.setStyle(this.widgetRect, 'width', this.deltaRight + 'px');
    const newSizeInRails = Math.round(this.deltaRight / this.widthOfOneRail);
    this.movingResizedInProcess.emit(newSizeInRails);
  }

  onUp(event: MouseEvent) {
    event.preventDefault();
    this.resizing.emit(false);
    const newSizeInRails = Math.round(this.deltaRight / this.widthOfOneRail);
    if (newSizeInRails) {
      this.newSize.emit(newSizeInRails);
      this.renderer.setStyle(this.widgetCmp, 'width', '' + this.deltaRight + 'px');
    }

    if (typeof PointerEvent !== 'undefined') {
      window.removeEventListener('pointermove', this.onMoveListener);
      window.removeEventListener('pointerup', this.onUpListener);
    } else {
      window.removeEventListener('mousemove', this.onMoveListener);
      window.removeEventListener('mouseup', this.onUpListener);
    }
  }

}
